import 'jquery-ui/ui/core';

let rowPrices = [];
window.rowPrices = rowPrices;

let checkboxData = {
    'credit_check': {
        onCheck: function () {
            $('#credit_check').closest('.box').attr('data-state', 'on' );
            $("#credit_check2").prop('checked', true);
        },
        onUncheck: function () {
            $('#credit_check').closest('.box').attr('data-state', 'off' );
            $("#credit_check2").prop('checked', false);
        },
    },
    'credit_check2': {},
    'tradein_check': {
        onCheck: function () {
            $('#tradein_check').closest('.box').attr('data-state', 'on' );
        },
        onUncheck: function () {
            $('#tradein_check').closest('.box').attr('data-state', 'off' );
        }
    },
    'tradein_check2': {},
    'util_check': {},
    'uds_check': {
        onCheck: function () {
            $('#uds_check').closest('.box').attr('data-state', 'on' );
        },
        onUncheck: function () {
            $('#uds_check').closest('.box').attr('data-state', 'off' );
        }
    },
};

$(function () {
    prepareRowDataToCalc();
    addHandlersToCheckboxes();
    addHandlersToRowButtons();
    priceAndComplictationFilter();
});

function priceAndComplictationFilter() {
    $('.comp-filter-raw select').each(function () {
        $(this).on('change', function() {
            doPriceAndComplictationFilterJob();
            
            var firstoption = $(this).find("option:eq(0)");
            if ($(this).val() == 0) {
                $(this).removeClass('active');
                $(firstoption).text( $(firstoption).data('name'));
            } else {
                $(this).addClass('active');
                $(firstoption).text('Показать все');
            }
        });

    });
}
function doPriceAndComplictationFilterJob() {
            $('.jsCarComplectationRow').parent().show();
            
            $('.comp-filter-raw select').each(function () {
              var value = $(this).val();
              var name = $(this).attr('name');
              
              $('.jsCarComplectationRow').each(function () {
                  if ($(this).find("."+name).length > 0 && ($(this).find("."+name).text() != value && value != 0)) {
                      $(this).parent().hide();
                  }
              
              });
            });
            
            
}
function prepareRowDataToCalc() {
    $('.jsCarComplectationRow').each(function () {
        rowPrices.push({
            self: this,
            price: parseInt($('[data-role="price"]', this).data('price')),
            discount: parseInt($('[data-role="discount"]', this).data('discount')),
            discountPrice: parseInt($('[data-role="discountPrice"]', this).data('discount-price'))
        });

    });
}

function addHandlersToCheckboxes() {
    for (let id in checkboxData) {

        $(`#${id}`).click(function (e) {
            let checkboxId = $(this).attr('id');
            let checked = $(this).prop('checked');
            let checkbox = checkboxData[checkboxId];

            if (checked) {
                if (typeof checkbox.onCheck === 'function') {
                    checkbox.onCheck();

                }
            } else {
                if (typeof checkbox.onUncheck === 'function') {
                    checkbox.onUncheck();
                }
            }

            calcComplectationTable();

        });
    }
    calcComplectationTable();
}

function addHandlersToRowButtons() {
    let $creditCheck = $('#credit_check');


    $('.jsPriceAndComplCreditButton').on('click', function () {
        if ($creditCheck.prop('checked') === false) {
            $creditCheck.trigger('click');
        }
    });

    $('.jsPriceAndComplCashButton').on('click', function () {
        if ($creditCheck.prop('checked') === true) {
            $creditCheck.trigger('click');
        }

    });
}

function calcComplectationTable() {
    let creditFlag = $('#credit_check').prop('checked');
    let creditSale = $('#credit_check').data('sale');
    let creditFlag2 = $('#credit_check2').prop('checked');
    let creditSale2 = $('#credit_check2').data('sale');
    


    let utilFlag = $('#util_check').prop('checked');
    let utilSale = $('#util_check').data('sale');

    let tradeinFlag = $('#tradein_check').prop('checked');
    let tradeinSale = $('#tradein_check').data('sale');
    let tradeinFlag2 = $('#tradein_check2').prop('checked');
    let $tradeinValue = $('.tradeinValue');

    let udsFlag = $('#uds_check').prop('checked');
    let udsSale = $('#uds_check').data('sale');

    let regionSale = $('[data-region]').data('region');
    
    //update label for credit2 (gosprogramm)
    /*
    //на будущее
    let creditFlag2Label = $('#credit_check2').closest('.box-credit').find('.label-secondary');
    if (creditFlag && creditFlag2) {
        $(creditFlag2Label).text("Скидка: "+(creditSale + (parseInt($('#main-card-price').data('price')) * 0.1) )+" ₽*");     
    }
    else {
        $(creditFlag2Label).text("Скидка: "+creditSale+" ₽*"); 
    }
    */



    for (let i = 0; i < rowPrices.length; i++) {
        let row = rowPrices[i];
        let price = row.price;
        let rowDiscount = 0;

        if(creditFlag) {
            rowDiscount += creditSale;

            if(creditFlag2) {
                rowDiscount += creditSale2;/*price*0.10;*/
            }
        }

        if(utilFlag) {
            rowDiscount += utilSale;
        }

        let tradeinValue = 0;
        if(tradeinFlag) {
            /*
            if(tradeinFlag2) {*/
                rowDiscount += tradeinSale;
                tradeinValue += tradeinSale;
            /*} else {
                rowDiscount += 60000;
                tradeinValue += 60000;
            }*/
            $tradeinValue.text(prettyNumber(tradeinValue));
        }

        if(udsFlag) {
            rowDiscount += udsSale;
        }

        rowDiscount += regionSale;

        let discountPrice = price - rowDiscount;
        row.discount = parseInt(rowDiscount, 10);
        row.discountPrice = parseInt(discountPrice, 10);
        /** update row */
        $('[data-role="discount"]', row.self).text(prettyNumber(row.discount));
        $('[data-role="discountPrice"]', row.self).text(prettyNumber(row.discountPrice));

        /** calc credit, tradein, discount */
        if (i === rowPrices.length - 1) {
            $('.num_counter').text(`${prettyNumber(parseInt(rowDiscount))}`);
            $('.num_counter').attr('data-count', `${parseInt(rowDiscount)}`);
        }
    }

    /** update other */
    let $form_price = $('#discount');
    let $total_discount = $('#discount-counted, #modal-discount');
    let newPriceFlag = $form_price.hasClass('jsNewPrice');
    let rowAttribute = newPriceFlag ? 'discountPrice' : 'discount';
    let rowIndex = 0;//newPriceFlag ? 0 : (rowPrices.length - 1);
    let row = rowPrices[rowIndex];
    let text_result = row[rowAttribute];
    
    let minCarPrice = parseInt($('#main-card-price').data('price'));
    
    $('#main-card-price').text(prettyNumber( minCarPrice - row.discount ) + ' ₽*');
    $("#contact-panel-price").text(prettyNumber( minCarPrice - row.discount ) + ' ₽');

    $form_price.text(prettyNumber(text_result) + ' ₽');
    $total_discount.text(prettyNumber(row.discount) + ' ₽');
}

/** call from twig */
window.getPriceAndPriceWithDiscount = function (urlData) {
    let row = $(this).parents('label');
    let eqid = row.data('eqid');
    let eqName = $('.compl-name',row).text();
    let price = $('[data-role="price"]', row).data('price');
    let discountPrice = $('[data-role="discountPrice"]', row).text().replace(/\s/g, '');
    urlData['price'] = price;
    urlData['discountPrice'] = discountPrice;
    urlData['eqid'] = eqid;
    urlData['eqName'] = eqName;
};
// заполнение линии
function countCheck() {
    $('.sale_check').click(function () {
        let chk_count = $('.sale_check').length;
        let lvl_count = $('.sale_check:checked').length;
        let line = $('.profit-line');
        //line.attr('data-count', lvl_count);
        if (chk_count === 2) {
            line.attr('data-count', lvl_count + 1);
        } else if ( $('#credit_10_check').is(':checked')) {
            line.attr('data-count', lvl_count + 1);
        }
        else {
            line.attr('data-count', lvl_count);
        }

    })
}
